var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPositionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8837 9.15312L12.2837 14.4531L7.68369 10.6531L3.08369 14.4531L4.48369 9.25313L0.283691 5.75313L5.68369 5.45312L7.68369 0.453125L9.68369 5.45312L15.0837 5.75313L10.8837 9.15312ZM9.68369 17.4531H8.68369V14.4531L7.68369 13.4531L6.68369 14.4531V17.4531H5.68369C4.58369 17.4531 3.68369 18.3531 3.68369 19.4531V20.4531H11.6837V19.4531C11.6837 18.3531 10.7937 17.4531 9.68369 17.4531Z",
    fill: "#13343B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionIcon);
export default __webpack_public_path__ + "static/media/position-icon.74c5b17e633dd08c89a8e7022cfc276d.svg";
export { ForwardRef as ReactComponent };